// MF-554 — Card components of the Chart Library, by the id an item declares in `card.component`
// (maestro-analytics api/src/library/items/cards.js). A new card = a component here + its item there.
import TermTrendCard from './TermTrendCard'
import KpiValueCard from './KpiValueCard'
import KpiBarCard from './KpiBarCard'
import ScoreListCard from './ScoreListCard'
import StudentProfileCard from './StudentProfileCard'
import SubjectGradesCard from './SubjectGradesCard'
import LatestAndTrendCard from './LatestAndTrendCard'
import AttendanceReportCard from './AttendanceReportCard'
import LearningSupportCard from './LearningSupportCard'
import WelfareIncidentsCard from './WelfareIncidentsCard'
import DemeritAlertCard from './DemeritAlertCard'

import PatClassRankingCard from './PatClassRankingCard'
import PatBandStanineGridCard from './PatBandStanineGridCard'
import PatClassDistributionCard from './PatClassDistributionCard'
import PatProgressPairsCard from './PatProgressPairsCard'
import PatProgressPanelsCard from './PatProgressPanelsCard'
import PatProgressFlowsCard from './PatProgressFlowsCard'
import PatResponseGuttmanCard from './PatResponseGuttmanCard'
import PatResponseMatrixCard from './PatResponseMatrixCard'
import PatNextLearningCard from './PatNextLearningCard'
import PatGrowthQuadrantsCard from './PatGrowthQuadrantsCard'
import PatStudentReportCard from './PatStudentReportCard'

export const CARD_COMPONENTS = {
  'term-trend': TermTrendCard,
  'kpi-value': KpiValueCard,
  'kpi-bar': KpiBarCard,
  'score-list': ScoreListCard,
  'student-profile': StudentProfileCard,
  'subject-grades': SubjectGradesCard,
  'latest-and-trend': LatestAndTrendCard,
  'attendance-report': AttendanceReportCard,
  'learning-support': LearningSupportCard,
  'welfare-incidents': WelfareIncidentsCard,
  'demerit-alert': DemeritAlertCard,
  'pat-class-ranking': PatClassRankingCard,
  'pat-band-stanine-grid': PatBandStanineGridCard,
  'pat-class-distribution': PatClassDistributionCard,
  'pat-progress-pairs': PatProgressPairsCard,
  'pat-progress-panels': PatProgressPanelsCard,
  'pat-progress-flows': PatProgressFlowsCard,
  'pat-response-guttman': PatResponseGuttmanCard,
  'pat-response-matrix': PatResponseMatrixCard,
  'pat-next-learning': PatNextLearningCard,
  'pat-growth-quadrants': PatGrowthQuadrantsCard,
  'pat-student-report': PatStudentReportCard
}

export default CARD_COMPONENTS
